import { render, staticRenderFns } from "./ChipsWithMoreNew.vue?vue&type=template&id=58790322"
import script from "./ChipsWithMoreNew.vue?vue&type=script&lang=ts"
export * from "./ChipsWithMoreNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58790322')) {
      api.createRecord('58790322', component.options)
    } else {
      api.reload('58790322', component.options)
    }
    module.hot.accept("./ChipsWithMoreNew.vue?vue&type=template&id=58790322", function () {
      api.rerender('58790322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChipsWithMoreNew.vue"
export default component.exports